<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2019 (original work) Open Assessment Technologies SA ;
    export let heading;
    export let content;
    export let status = 'info';
    export let fullwidth = false;

    const statuses = Object.freeze({
        info: 'info',
        warning: 'warning',
        success: 'success'
    });
</script>

<style>
    .feedback {
        max-width: 40rem;
        padding: var(--space-half) var(--space-2x);
        margin: var(--space-1x5) auto;
        text-align: center;

        &.info {
            @add-mixin info;
        }
        &.warning {
            @add-mixin warning;
        }
        &.fullwidth {
            @add-mixin fullwidth;
        }
        & h4 {
            margin-top: var(--space-1x5);
        }
        & p {
            margin: var(--space-1x);
        }
    }
</style>

<div aria-atomic={true} role={status === statuses.warning ? 'alert' : 'status'} class="feedback {status}" class:fullwidth>
    {#if heading}
        <h4 class="heading">{heading}</h4>
    {/if}
    <p>{content}</p>
</div>
